import { featureToggles } from '@space-shell/constant/baseLayout'

export const useShowGroups = (communityOwnerId?: number): boolean => {
  const { featureNewCommunityMenuStructure, featureShouldRenderRoomsAndGroups } = featureToggles

  if (
    featureNewCommunityMenuStructure &&
    Number(communityOwnerId) >= featureShouldRenderRoomsAndGroups
  ) {
    return true
  }

  return false
}
